import { JSX, ReactNode } from 'react'
import { createTheme, Theme, ThemeProvider } from '@mui/material/styles'

const theme: Theme = createTheme({
    typography: {
        fontFamily: "'Poppins', Arial, Helvetica, sans-serif",
        h1: { fontFamily: "'BobbyJones', Arial, sans-serif" },
        h2: { fontFamily: "'BobbyJones', Arial, sans-serif" },
        h3: { fontFamily: "'Poppins', Arial, sans-serif" },
        h4: { fontFamily: "'Poppins', Arial, sans-serif" },
        h5: { fontFamily: "'Poppins', Arial, sans-serif" },
        h6: { fontFamily: "'Poppins', Arial, sans-serif" }
    }
})

export default function MuiThemeProvider({ children }: Readonly<{ children: ReactNode }>): JSX.Element {
    return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
